import { combineReducers } from 'redux';

const categories = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_CATEGORIES':
      return action.categories;
    default:
      return state;
  }
};

const products = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_PRODUCTS':
      return action.products;
    default:
      return state;
  }
};

const news = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_NEWS':
      return action.news;
    default:
      return state;
  }
};

const locations = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_LOCATIONS':
      return action.locations;
    default:
      return state;
  }
};

const pages = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_PAGES':
      return action.pages;
    default:
      return state;
  }
};

const contacts = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_CONTACTS':
      return action.contacts;
    default:
      return state;
  }
};

const banners = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_BANNERS':
      return action.banners;
    default:
      return state;
  }
};

const homeslideshows = (state = [], action) => {
  switch (action.type) {
    case 'UPDATE_HOMESLIDESHOWS':
      return action.homeslideshows;
    default:
      return state;
  }
};

const appReducer = combineReducers({
  categories,
  products,
  news,
  locations,
  pages,
  contacts,
  banners,
  homeslideshows
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js